import { createSVGIcon } from "@faire/web--source/slate/icons/util";
import * as React from "react";

export const PreciseFitIcon = createSVGIcon(
  <>
    <path
      d="M16 1L16 2.5M16 31.5L16 26"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 2.5H13.5L13 6L8.34039 7.13781C7.67946 7.2992 7.36915 8.05919 7.72823 8.63706L11.4254 14.5869C11.745 15.1012 11.596 15.7767 11.0897 16.1089C8.1391 18.0449 6.27811 21.2625 6.07129 24.7855L6 26H26L25.929 24.7899C25.722 21.2635 23.8618 18.0419 20.9111 16.0997C20.4042 15.766 20.2557 15.0892 20.5763 14.5739L24.2705 8.63739C24.6301 8.05952 24.3199 7.29904 23.6587 7.13759L19 6L18.5 2.5Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <line
      x1="12.5"
      y1="31.5"
      x2="19.5"
      y2="31.5"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3779 5.7002C13.017 7.05929 14.3985 8.0002 15.9997 8.0002C17.601 8.0002 18.9825 7.05929 19.6216 5.7002H18.4719C17.9309 6.48545 17.0254 7.0002 15.9997 7.0002C14.9741 7.0002 14.0686 6.48545 13.5276 5.7002H12.3779Z"
      fill="currentColor"
    />
  </>,
  "PreciseFitIcon",
  {
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    fill: "none",
  }
);
